import { Drawer } from "~/components/ui-components/v2"

import { EquipmentForm } from "./EquipmentForm"

/** Drawer presentation for the shared Finance Partner & Equipment editor. */
export const EquipmentStep = ({
  proposalId,
  onClose,
  onSaved = onClose,
}: {
  proposalId: string
  onClose: () => void
  /** Where a successful save goes; defaults to closing the drawer. */
  onSaved?: () => void
}): JSX.Element => (
  <Drawer
    open
    theme="dark"
    onClose={onClose}
    title="Finance Plan and Equipment Selection"
    description="Configure Battery System Type and AVL-approved battery equipment"
    widthClass="sm:max-w-2xl"
    data-testid="equipment-step"
  >
    <EquipmentForm proposalId={proposalId} onClose={onClose} onSaved={onSaved} />
  </Drawer>
)
